import React, { useState } from 'react';
import { StringUtil } from 'utils/StringUtil';
import ImageInfoModuleMobile from 'components/templates/imageInfoModuleMobile';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';

const EDesignMobile = props => {
  const { data } = props.data;
  const { breadcrumbList } = props;
  const [showDescriptionLayout, setShowDescriptionLayout] = useState(false);
  const eDesignData = data && data.eDesign;
  const customiseWithEDesign = data && data.customiseWithEDesign;
  let paragraph = StringUtil.sliceHtml(eDesignData.sub_heading_mobile);
  const eDesignImageMobile = eDesignData.image_mobile;

  const showOverlay = showDescriptionLayout ? (
    <OverlayPortal>
      <OverlayModal
        data={customiseWithEDesign}
        theme={'light-theme'}
        type={'description-overlay'}
        openFor={'eDesign'}
        onClosePress={() => setShowDescriptionLayout(false)}
        breadcrumbList={[
          {
            breadcrumbName: breadcrumbList[1].breadcrumbName,
            breadcrumbLink: breadcrumbList[1].breadcrumbLink,
          },
        ]}
      />
    </OverlayPortal>
  ) : null;

  return (
    <div>
      <ImageInfoModuleMobile
        heading={eDesignData.heading}
        content={paragraph}
        imageData={eDesignImageMobile}
        buttonName={customiseWithEDesign ? 'EXPLORE' : false}
        onClickButton={() => setShowDescriptionLayout(true)}
        togglePadding={data.togglePadding}
      />
      {showOverlay}
    </div>
  );
};

export default EDesignMobile;
